import React from "react";
import { QuestionCircleOutlined, LineChartOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ProductLockPage from "components/ProductLock/ProductLockPage";
import lockStyles from "components/ProductLock/style.module.scss";

/** Shown on /console/teach-ai to accounts that don't have Teach the AI enabled. */
const TeachAILockPage = () => {
  const { t } = useTranslation();
  const theme = useSelector((state) => state.DashboardReducer.theme) || "dark";
  return (
    <ProductLockPage productKey="teach_ai" theme={theme}>
      <div className={lockStyles.lockCardGhostOne}>
        <QuestionCircleOutlined />
        <span>{t("teach_ai_lock.ghost_question")}</span>
        <strong>{t("teach_ai_lock.ghost_answers")}</strong>
      </div>
      <div className={lockStyles.lockCardGhostTwo}>
        <LineChartOutlined />
        <span>{t("teach_ai_lock.ghost_accuracy")}</span>
        <strong>{t("teach_ai_lock.ghost_tested")}</strong>
      </div>
    </ProductLockPage>
  );
};

export default TeachAILockPage;
